import { getTrackingPageType, PageType, toNewPageType } from "@reco/service/src/utils/pageType";
import { useLocale } from "@reco/shared/src/composables/useLocale";
import { normalizeLocale } from "@reco/widgets/src/utils";
import { defineStore } from "pinia";
import { computed } from "vue";

/**
 * Shared store that is accessible across all widget instances on the page
 */
export const usePageStore = defineStore("page", () => {
  const localeContext = useLocale();
  const pageType = computed<PageType | string>(() => getTrackingPageType());
  const newPageType = computed(() => toNewPageType(pageType.value));
  const normalizedLocale = computed(() => normalizeLocale(localeContext.locale.value));

  return {
    locale: localeContext.locale.value,
    country: localeContext.country.value,
    language: localeContext.language.value,
    normalizedLocale,
    pageType,
    newPageType,
  };
});
